import { useCallback, useEffect, useState } from "react";
import { getAge } from "../../services/customerTouchPoint";

const useAge = () => {
    const [data1, setData1] = useState([]);

    const fetchData = useCallback(async () => {
        const res = await getAge();
        let newValue = [];
        if (res.data.code === "0000") {
            setData1(res.data.objectValue);
        }
    }, [setData1]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data1];
};

export default useAge;
